<p>
  tree-dialog works!
</p>
